/* tslint:disable */
import {
  MeterReading,
  ChartOfAccount,
  CompanyAccount
} from '../index';

declare var Object: any;
export interface MeterReadingEntryInterface {
  "reading_date": Date;
  "billing_date"?: Date;
  "invoice_due_date"?: Date;
  "billed": boolean;
  "description"?: string;
  "total_usage": number;
  "unit_cost"?: number;
  "base_charge"?: number;
  "chart_of_account_id": number;
  "property_id": number;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  meterReading?: MeterReading[];
  chartOfAccount?: ChartOfAccount;
  property?: CompanyAccount;
}

export class MeterReadingEntry implements MeterReadingEntryInterface {
  "reading_date": Date;
  "billing_date": Date;
  "invoice_due_date": Date;
  "billed": boolean;
  "description": string;
  "total_usage": number;
  "unit_cost": number;
  "base_charge": number;
  "chart_of_account_id": number;
  "property_id": number;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  meterReading: MeterReading[];
  chartOfAccount: ChartOfAccount;
  property: CompanyAccount;
  constructor(data?: MeterReadingEntryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `MeterReadingEntry`.
   */
  public static getModelName() {
    return "MeterReadingEntry";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of MeterReadingEntry for dynamic purposes.
  **/
  public static factory(data: MeterReadingEntryInterface): MeterReadingEntry{
    return new MeterReadingEntry(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'MeterReadingEntry',
      plural: 'MeterReadingEntries',
      path: 'MeterReadingEntries',
      idName: 'id',
      properties: {
        "reading_date": {
          name: 'reading_date',
          type: 'Date'
        },
        "billing_date": {
          name: 'billing_date',
          type: 'Date'
        },
        "invoice_due_date": {
          name: 'invoice_due_date',
          type: 'Date'
        },
        "billed": {
          name: 'billed',
          type: 'boolean',
          default: false
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "total_usage": {
          name: 'total_usage',
          type: 'number'
        },
        "unit_cost": {
          name: 'unit_cost',
          type: 'number',
          default: 0
        },
        "base_charge": {
          name: 'base_charge',
          type: 'number',
          default: 0
        },
        "chart_of_account_id": {
          name: 'chart_of_account_id',
          type: 'number'
        },
        "property_id": {
          name: 'property_id',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        meterReading: {
          name: 'meterReading',
          type: 'MeterReading[]',
          model: 'MeterReading',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'meter_reading_entry_id'
        },
        chartOfAccount: {
          name: 'chartOfAccount',
          type: 'ChartOfAccount',
          model: 'ChartOfAccount',
          relationType: 'belongsTo',
                  keyFrom: 'chart_of_account_id',
          keyTo: 'id'
        },
        property: {
          name: 'property',
          type: 'CompanyAccount',
          model: 'CompanyAccount',
          relationType: 'belongsTo',
                  keyFrom: 'property_id',
          keyTo: 'id'
        },
      }
    }
  }
}
